<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')">
        <el-col :span="12">
          <el-form-item :label="$t('manage.name37')" prop="loginName">
            <el-input v-model="queryInfo.name" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getPageList" v-if="buttonPerms.indexOf('sysmenu/list') > -1">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addRule(null)" v-if="buttonPerms.indexOf('sysmenu/add') > -1">{{ $t('manage.name49') }}</el-button>
    </div>
    <el-table
      v-loading="tableLoading"
      :data="tableList"
      :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }"
      default-expand-all
      row-key="menuId"
      :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="ID" prop="menuId" sortable></el-table-column>
      <el-table-column :label="$t('manage.name38')" prop="menuName" sortable>
        <template slot-scope="scope">
          <div v-if="lang === 'zh'">{{ $t(scope.row.menuName) }}</div>
          <div v-else>{{ $t(scope.row.emenuName) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name39')" prop="perms" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.menuType === 'C'"></div>
          <div v-else>{{ scope.row.perms }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name40')" prop="menuType" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.menuType === 'C'">{{ [$t('screen.name35'), $t('screen.name36'), $t('screen.name37')][scope.row.level] }}{{ $t('manage.name46') }}</div>
          <div v-else>{{ $t('screen.name38') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name41')" prop="component" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.menuType === 'C'">{{ scope.row.component }}</div>
          <div v-else></div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('manage.name12')" prop="status" sortable width="92">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status"
            :disabled="buttonPerms.indexOf('sysmenu/updateShowStatus') > -1 ? false : true"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            @change="changeSwitch(scope.row, $event)"
          >
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.level < 3 && buttonPerms.indexOf('sysmenu/add') > -1" @click="addRule(scope.row)">{{ $t('manage.name42') }}</el-button>
          <el-button type="text" v-if="2 < scope.row.level > 4 && scope.row.menuType === 'C' && buttonPerms.indexOf('sysmenu/add') > -1" @click="addRule(1, scope.row)">{{
            $t('manage.name42')
          }}</el-button>
          <el-button type="text" @click="editRule(scope.row)" v-if="buttonPerms.indexOf('sysmenu/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="handleDel(scope.row)" style="color:#ea4646" v-if="buttonPerms.indexOf('sysmenu/delete') > -1">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog width="688px" :title="$t('manage.name43')" v-if="userInfoDialog" :visible.sync="userInfoDialog" :before-close="close">
      <el-form :label-width="formLabelWidth('lg')">
        <el-form-item prop="menuType" :label="$t('manage.name44')">
          <el-radio v-model="userInfo.menuType" label="A">{{ $t('manage.name45') }}</el-radio>
          <el-radio v-model="userInfo.menuType" label="C">{{ $t('manage.name46') }}</el-radio>
        </el-form-item>
      </el-form>

      <el-form ref="userFormRef" :model="userInfo" :rules="userInfoRules" :label-width="formLabelWidth('lg')" v-if="userInfo.menuType === 'A'">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="menuName" :label="$t('manage.name47')">
              <el-input v-model="userInfo.menuName" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="emenuName" :label="$t('manage.name104')">
              <el-input v-model="userInfo.emenuName" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="component" :label="$t('manage.name51')">
              <el-input v-model="userInfo.component" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="sort" :label="$t('manage.name54')">
              <el-input v-model="userInfo.sort" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="pid" :label="$t('manage.name48')">
              <el-input v-model="userInfo.pName" disabled :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="status" :label="$t('manage.name2')">
              <el-switch v-model="userInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-form ref="userFormRef" :model="userInfo" :rules="userInfoRules" :label-width="formLabelWidth('lg')" v-if="userInfo.menuType === 'C'">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="menuName" :label="$t('manage.name95')">
              <el-input v-model="userInfo.menuName" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="emenuName" :label="$t('manage.name105')">
              <el-input v-model="userInfo.emenuName" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="component" :label="$t('manage.name52')">
              <el-input v-model="userInfo.component" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="perms" :label="$t('manage.name53')">
              <el-input v-model="userInfo.perms" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="sort" :label="$t('manage.name54')">
              <el-input v-model="userInfo.sort" :placeholder="$t('public.name5')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="icon" :label="$t('manage.name55')">
              <div class="upload-layout">
                <el-upload class="avatar-uploader" action :http-request="handleUpLoadFile" :show-file-list="false">
                  <img v-if="userInfo.icon" :src="userInfo.icon" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>{{ $t('manage.name56') }}</div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="status" :label="$t('manage.name2')">
              <el-switch v-model="userInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="pid" :label="$t('manage.name48')">
              <el-input v-model="userInfo.pName" disabled :placeholder="$t('public.name5')"></el-input>
              <!-- <el-select v-model="userInfo.pid" :placeholder="$t('public.name1')" style="width:224px;">
                <el-option v-for="item in parentTypeList" :key="item.menuId" :label="$t(item.menuName)" :value="item.menuId"> </el-option>
              </el-select> -->

              <!-- <el-cascader
                :value="cascadervalue"
                @change="handleChange"
                :props="{ children: 'childList', checkStrictly: true, hasChildren: 'hasChildren', expandTrigger: 'hover', value: 'menuId', label: 'menuName' }"
                :options="parentTypeList"
              >
                <template slot-scope="{ data }">
                  <span>{{ $t(data.menuName) }}</span>
                </template>
              </el-cascader> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="visible" :label="$t('manage.name57')">
              <el-switch v-model="userInfo.visible" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { uploadFile, sysmenuAdd, sysmenuList, sysmenuDelete, sysmenuUpdate, updateShowStatus } from '@/api/manage.js'
import AppDialog from '@/components/AppDialog/index.vue'
import { getStoredLocale } from '@/config/flavor'
export default {
  components: { AppDialog },
  computed: {
    statusOptions() {
      return [
        { value: 2, label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    }
  },
  data() {
    return {
      cascadervalue: '',
      queryInfo: {
        page: 1,
        limit: 10,
        name: '',
        status: 2
      },
      tableList: [],
      total: 0,
      selectList: [],
      userInfoRules: {
        menuName: [
          {
            required: true,
            message: this.$t('screen.name39'),
            trigger: 'blur'
          }
        ],
        emenuName: [
          {
            required: true,
            message: this.$t('screen.name40'),
            trigger: 'blur'
          }
        ],
        component: [
          {
            required: true,
            message: this.$t('screen.name41'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {
        menuName: '',
        emenuName: '',
        component: '',
        menuType: 'A',
        perms: '',
        pid: '',
        sort: '',
        icon: '',
        status: true,
        visible: false,
        menuId: '',
        pName: ''
      },
      type: 1,
      rolesInfo: {
        roles: ''
      },
      parentTypeList: [],
      userInfoDialog: false,
      rolesOptions: [],
      buttonPerms: '',
      allDataList: [],
      tableLoading: false,
      loading: false,
      lang: ''
    }
  },
  created() {
    this.lang = getStoredLocale()

    console.log('====', this.lang)
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {},
  methods: {
    addRule(row) {
      if (row !== null) {
        if (row.level === 2) {
          this.userInfo.menuType = 'A'
        } else {
          this.userInfo.menuType = 'C'
        }
        this.userInfo.pid = row.menuId
        this.userInfo.menuId = row.menuId
        this.userInfo.pName = this.$t(row.parentName)
        this.userInfo.status = row.status
        this.userInfo.visible = row.visible
      }
      this.userInfoDialog = true
      this.type = 1
    },
    editRule(row) {
      this.type = 3
      this.userInfoDialog = true
      this.userInfo = {
        menuId: row.menuId,
        menuName: row.menuName,
        emenuName: row.emenuName,
        component: row.component,
        menuType: row.menuType,
        perms: row.perms,
        pName: this.$t(row.parentName),
        sort: row.orderNum,
        pid: row.pid || '',
        icon: row.icon,
        status: row.status,
        visible: row.visible
      }
    },
    close() {
      this.userInfoDialog = false
      this.userInfo = {
        menuName: '',
        emenuName: '',
        component: '',
        menuType: 'A',
        perms: '',
        sort: '',
        pid: '',
        pName: '',
        icon: '',
        status: true,
        visible: false,
        menuId: ''
      }
      this.iconUrl = ''
    },
    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        const menuInfo = {
          component: this.userInfo.component,
          icon: this.userInfo.icon,
          status: this.userInfo.status,
          visible: this.userInfo.visible,
          pid: this.userInfo.pid,
          id: this.userInfo.menuId,
          menuType: this.userInfo.menuType,
          menuName: this.userInfo.menuName,
          emenuName: this.userInfo.emenuName,
          perms: this.userInfo.component,
          sort: this.userInfo.sort
        }
        if (this.type === 3) {
          sysmenuUpdate(menuInfo)
            .then(res => {
              this.close()
              this.queryList()
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          sysmenuAdd(menuInfo)
            .then(res => {
              this.close()
              this.queryList()
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    handleDel(row) {
      this.$confirm(this.$t('screen.name42'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          sysmenuDelete(row.menuId)
            .then(res => {
              if (res.code === 200) {
                this.queryList()
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    changeSwitch(row, e) {
      const tip = row.status ? this.$t('screen.name43') : this.$t('screen.name44')
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.tableLoading = true
          updateShowStatus(row.menuId)
            .then((res) => {
              this.tableLoading = false
              this.queryList()
            })
            .catch(() => {
              this.tableLoading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    deWeight(tableList) {
      for (var i = 0; i < tableList.length - 1; i++) {
        for (var j = i + 1; j < tableList.length; j++) {
          if (tableList[i].menuId === tableList[j].menuId) {
            tableList.splice(j, 1)
            j--
          }
        }
      }
      return tableList
    },

    resetQuery() {
      this.queryInfo = {
        page: 1,
        limit: 10,
        name: '',
        status: 2
      }
      this.queryList()
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.queryInfo.name) {
        data.name = this.queryInfo.name.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      sysmenuList(data)
        .then(res => {
          this.tableList = res.data.list
          this.allDataList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.allDataList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    // handleChange(value) {
    //   console.log('value==1', value)
    //   console.log('cascadervalue==1', this.cascadervalue)
    //   this.cascadervalue = '12313'
    // },

    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.userInfo.icon = res.data.fileUrl
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>

<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      line-height: 16.8px;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
.map {
  width: 100%;
  height: 800px;
}
</style>
